import { Component, input } from '@angular/core'

@Component({
  selector: 'app-sidebar-group-title',
  imports: [],
  templateUrl: './sidebar-group-title.component.html',
  styleUrl: './sidebar-group-title.component.scss',
})
export class SidebarGroupTitleComponent {
  title = input.required<string>()
}
